import React from 'react';
import './DateSeparator.scss';

interface DateSeparatorProps {
    date: string;
}

const DateSeparator: React.FC<DateSeparatorProps> = ({ date }) => {
    return (
        <div className="date-separator">
            <div className="date-separator-line"></div>
            <div className="date-separator-text">{date}</div>
            <div className="date-separator-line"></div>
        </div>
    );
};

export default DateSeparator;

